import { motion } from "framer-motion";
import { Eyebrow } from "@/components/Reveal";

export const PageHeader = ({ eyebrow, title, accent, description, children }) => (
  <section className="pt-32 sm:pt-44 pb-12 sm:pb-16 border-b border-[#ECEAE4]" data-testid="page-header">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
      <motion.h1
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="font-display text-5xl sm:text-6xl lg:text-7xl font-medium leading-[1.02] tracking-tight text-[#2C2A29] mt-4"
      >
        {title} {accent && <span className="italic text-[#9E8773]">{accent}</span>}
      </motion.h1>
      {description && <p className="mt-6 text-lg text-[#5E5A54] font-light leading-relaxed max-w-2xl">{description}</p>}
      {children}
    </div>
  </section>
);
